import {IActivityXpedition} from './interfaces';
import {IAction} from '../interface';
import {InferActionsTypes} from '../helpers';

export const SET_ACTIVITIES = 'SET_ACTIVITIES';
export const setActivities = (activities: IActivityXpedition[]): IAction<IActivityXpedition[]> => ({
  type: SET_ACTIVITIES,
  payload: activities
});

const activityActions = {
  setActivities
};

export type ActivityActionsType = InferActionsTypes<typeof activityActions>
